var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckSignUpBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 18.9286,
    stroke: "#7FC5ED",
    strokeWidth: 2.14286
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7045 15.6993C26.0744 15.3245 26.6742 15.3245 27.0441 15.6993C27.4095 16.0696 27.4139 16.667 27.0575 17.0428L19.4897 25.9887C19.4824 25.9979 19.4746 26.0067 19.4664 26.0151C19.0965 26.3899 18.4968 26.3899 18.1268 26.0151L13.5216 21.3485C13.1517 20.9736 13.1517 20.3659 13.5216 19.9911C13.8915 19.6163 14.4912 19.6163 14.8611 19.9911L18.7681 23.9501L25.6794 15.728C25.6872 15.718 25.6956 15.7084 25.7045 15.6993Z",
    fill: "#7FC5ED"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSignUpBlue);
export default __webpack_public_path__ + "static/media/check-signUp-blue.f7d26955933f5e53e72a251078a38aae.svg";
export { ForwardRef as ReactComponent };